import 'ui-core/components/accordion/js/accordion';

(function () {
    const accordion = UX.accordion;
    // TODO: remove this line after the fix in the core
    accordion.on.toggle.tabbed = function ($this) {
        const $parent = $this.closest('.accordion-tabbed__tab');
        const $opened = $this.closest('.accordion-tabbed').children('.js--open');

        const state = !($this.attr('aria-expanded') === 'true');
        $this.attr('aria-expanded', state);
        const $wrapper = $this.closest('.expandable-accordion');
        if ($wrapper.length) accordion.on.checkExpandAll($this, state, $wrapper);
        if (!$parent.hasClass('js--open')) {
            if (accordion.collapseAccordion || accordion.extraCollapseAccordionCheck($parent)) {
                $opened.find('.accordion-tabbed__content').slideUp(200);
            }
            $parent.find('.accordion-tabbed__content').slideDown(200, function () {
                if (accordion.collapseAccordion || accordion.extraCollapseAccordionCheck($parent)) {
                    $opened.removeClass('js--open');
                }

                $parent.addClass('js--open');
                if ($parent.attr('data-ajaxLoaded') !== 'true' && $parent.find('.accordion-lazy').length) {
                    accordion.getAccordionContent($parent.find('.accordion-lazy'));
                }
                accordion.on.expanded($this);
                const accordionExpandedTabbed = $.Event('accordion:expandedTabbed');
                $(document).trigger(accordionExpandedTabbed, [$this]);
            });
        } else {
            $parent.find('.accordion-tabbed__content').slideUp(200, function () {
                $this.removeClass('js--open');
                $parent.removeClass('js--open');
            });
        }
    };
    $(document).on('showRecommended:loaded', () => {
        if ($('.tab__pane #relatedTab3').length && $('.tab__pane .accordion-tabbed').children().length > 1) {
            UX.accordion.openedAccordion = 1;
        } else {
            UX.accordion.openedAccordion = 0;
        }
        UX.accordion.init();
    });
})();
